<div class="container">
  <div nz-row nzAlign="middle">
    <div nz-col nzLg="24" nzMd="24" nzSm="24" nzXs="24">
      <div class="copyrighttxt">© 2023 Mockshala. All rights reserved.</div>
    </div>
  </div>
</div>
